import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "להכיר את הנושא",
    opening: localizedGenderNode(
      [
      "היום אני נשאר/ת עם עצמי סביב הנושא הזה.",
      "אני לא פותר/ת.",
      "אני רק שם/ה לב."
    ],
      [
      "היום אני נשאר/ת עם עצמי סביב הנושא הזה.",
      "אני לא פותר/ת.",
      "אני רק שם/ה לב."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הדבר הזה מבקש ממני היום?",
      "איפה זה יושב בי עכשיו?",
      "מה מרגיש עדין מדי לומר בקול?"
    ],
      [
      "מה הדבר הזה מבקש ממני היום?",
      "איפה זה יושב בי עכשיו?",
      "מה מרגיש עדין מדי לומר בקול?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני נותן/ת למה שעלה להיות כאן."
    ],
      [
      "אני נותן/ת למה שעלה להיות כאן."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת.",
      "נשימה אחת."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "הטריגר הראשון",
    opening: localizedGenderNode(
      [
      "היום אני נשאר/ת עם עצמי סביב הנושא הזה.",
      "אני לא פותר/ת.",
      "אני רק שם/ה לב."
    ],
      [
      "היום אני נשאר/ת עם עצמי סביב הנושא הזה.",
      "אני לא פותר/ת.",
      "אני רק שם/ה לב."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הטריגר הראשון שאני מזהה?",
      "מה אני מרגיש/ה בשנייה הראשונה?",
      "מה הייתי בוחר/ת/ה באותו רגע?"
    ],
      [
      "מה הטריגר הראשון שאני מזהה?",
      "מה אני מרגיש/ה בשנייה הראשונה?",
      "מה הייתי בוחר/ת/ה באותו רגע?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני נותן/ת למה שעלה להיות כאן."
    ],
      [
      "אני נותן/ת למה שעלה להיות כאן."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת.",
      "נשימה אחת."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "מה קורה בגוף",
    opening: localizedGenderNode(
      [
      "היום אני נשאר/ת עם עצמי סביב הנושא הזה.",
      "אני לא פותר/ת.",
      "אני רק שם/ה לב."
    ],
      [
      "היום אני נשאר/ת עם עצמי סביב הנושא הזה.",
      "אני לא פותר/ת.",
      "אני רק שם/ה לב."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה בגוף אני מרגיש/ה את זה עכשיו?",
      "איך הנשימה שלי כשזה עולה?",
      "מה הגוף שלי מנסה לספר לי?"
    ],
      [
      "איפה בגוף אני מרגיש/ה את זה עכשיו?",
      "איך הנשימה שלי כשזה עולה?",
      "מה הגוף שלי מנסה לספר לי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני נותן/ת למה שעלה להיות כאן."
    ],
      [
      "אני נותן/ת למה שעלה להיות כאן."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת.",
      "נשימה אחת."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "הסיפור שאני מספר/ת לעצמי",
    opening: localizedGenderNode(
      [
      "היום אני נשאר/ת עם עצמי סביב הנושא הזה.",
      "אני לא פותר/ת.",
      "אני רק שם/ה לב."
    ],
      [
      "היום אני נשאר/ת עם עצמי סביב הנושא הזה.",
      "אני לא פותר/ת.",
      "אני רק שם/ה לב."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזו מחשבה עולה מיד?",
      "איזה סיפור אני מספר/ת על זה?",
      "איזו אפשרות רכה יותר קיימת?"
    ],
      [
      "איזו מחשבה עולה מיד?",
      "איזה סיפור אני מספר/ת על זה?",
      "איזו אפשרות רכה יותר קיימת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני נותן/ת למה שעלה להיות כאן."
    ],
      [
      "אני נותן/ת למה שעלה להיות כאן."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת.",
      "נשימה אחת."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "הצורך שמתחת",
    opening: localizedGenderNode(
      [
      "היום אני נשאר/ת עם עצמי סביב הנושא הזה.",
      "אני לא פותר/ת.",
      "אני רק שם/ה לב."
    ],
      [
      "היום אני נשאר/ת עם עצמי סביב הנושא הזה.",
      "אני לא פותר/ת.",
      "אני רק שם/ה לב."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הצורך שמתחת לזה?",
      "איך אני מנסה לענות עליו עכשיו?",
      "איך הייתי רוצה לבקש אותו בעדינות?"
    ],
      [
      "מה הצורך שמתחת לזה?",
      "איך אני מנסה לענות עליו עכשיו?",
      "איך הייתי רוצה לבקש אותו בעדינות?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני נותן/ת למה שעלה להיות כאן."
    ],
      [
      "אני נותן/ת למה שעלה להיות כאן."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת.",
      "נשימה אחת."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "גבול פנימי קטן",
    opening: localizedGenderNode(
      [
      "היום אני נשאר/ת עם עצמי סביב הנושא הזה.",
      "אני לא פותר/ת.",
      "אני רק שם/ה לב."
    ],
      [
      "היום אני נשאר/ת עם עצמי סביב הנושא הזה.",
      "אני לא פותר/ת.",
      "אני רק שם/ה לב."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה גבול קטן שיגן עלי היום?",
      "איפה אני חוצה גבול של עצמי?",
      "איך יישמע משפט גבול פנימי?"
    ],
      [
      "מה גבול קטן שיגן עלי היום?",
      "איפה אני חוצה גבול של עצמי?",
      "איך יישמע משפט גבול פנימי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני נותן/ת למה שעלה להיות כאן."
    ],
      [
      "אני נותן/ת למה שעלה להיות כאן."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת.",
      "נשימה אחת."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "עצירה באמצע",
    opening: localizedGenderNode(
      [
      "היום אני נשאר/ת עם עצמי סביב הנושא הזה.",
      "אני לא פותר/ת.",
      "אני רק שם/ה לב."
    ],
      [
      "היום אני נשאר/ת עם עצמי סביב הנושא הזה.",
      "אני לא פותר/ת.",
      "אני רק שם/ה לב."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הסימן הראשון שהלופ מתחיל?",
      "איזו עצירה קטנה אפשרית לי?",
      "מה אני מפחד/ת שיקרה אם אעצור?"
    ],
      [
      "מה הסימן הראשון שהלופ מתחיל?",
      "איזו עצירה קטנה אפשרית לי?",
      "מה אני מפחד/ת שיקרה אם אעצור?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני נותן/ת למה שעלה להיות כאן."
    ],
      [
      "אני נותן/ת למה שעלה להיות כאן."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת.",
      "נשימה אחת."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "רכות כלפי עצמי",
    opening: localizedGenderNode(
      [
      "היום אני נשאר/ת עם עצמי סביב הנושא הזה.",
      "אני לא פותר/ת.",
      "אני רק שם/ה לב."
    ],
      [
      "היום אני נשאר/ת עם עצמי סביב הנושא הזה.",
      "אני לא פותר/ת.",
      "אני רק שם/ה לב."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזו מילה רכה אני יכול/ה להגיד לעצמי?",
      "מה הייתי אומר/ת לחבר/ה במקומי?",
      "מה משתנה בי כשאני שומע/ת את זה?"
    ],
      [
      "איזו מילה רכה אני יכול/ה להגיד לעצמי?",
      "מה הייתי אומר/ת לחבר/ה במקומי?",
      "מה משתנה בי כשאני שומע/ת את זה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני נותן/ת למה שעלה להיות כאן."
    ],
      [
      "אני נותן/ת למה שעלה להיות כאן."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת.",
      "נשימה אחת."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "הפחד שמתחת",
    opening: localizedGenderNode(
      [
      "היום אני נשאר/ת עם עצמי סביב הנושא הזה.",
      "אני לא פותר/ת.",
      "אני רק שם/ה לב."
    ],
      [
      "היום אני נשאר/ת עם עצמי סביב הנושא הזה.",
      "אני לא פותר/ת.",
      "אני רק שם/ה לב."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הפחד שמתחת לזה?",
      "איך אני מגן/ה על עצמי ממנו?",
      "מה אני בוחר/ת/ה כדי להרגיש בטוח/ה יותר?"
    ],
      [
      "מה הפחד שמתחת לזה?",
      "איך אני מגן/ה על עצמי ממנו?",
      "מה אני בוחר/ת/ה כדי להרגיש בטוח/ה יותר?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני נותן/ת למה שעלה להיות כאן."
    ],
      [
      "אני נותן/ת למה שעלה להיות כאן."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת.",
      "נשימה אחת."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "אחריות רכה",
    opening: localizedGenderNode(
      [
      "היום אני נשאר/ת עם עצמי סביב הנושא הזה.",
      "אני לא פותר/ת.",
      "אני רק שם/ה לב."
    ],
      [
      "היום אני נשאר/ת עם עצמי סביב הנושא הזה.",
      "אני לא פותר/ת.",
      "אני רק שם/ה לב."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה חלקי בלי להאשים את עצמי?",
      "מה לא שלי לשאת?",
      "איזו בחירה קטנה כן בשליטתי?"
    ],
      [
      "מה חלקי בלי להאשים את עצמי?",
      "מה לא שלי לשאת?",
      "איזו בחירה קטנה כן בשליטתי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני נותן/ת למה שעלה להיות כאן."
    ],
      [
      "אני נותן/ת למה שעלה להיות כאן."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת.",
      "נשימה אחת."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "משפט חדש קטן",
    opening: localizedGenderNode(
      [
      "היום אני נשאר/ת עם עצמי סביב הנושא הזה.",
      "אני לא פותר/ת.",
      "אני רק שם/ה לב."
    ],
      [
      "היום אני נשאר/ת עם עצמי סביב הנושא הזה.",
      "אני לא פותר/ת.",
      "אני רק שם/ה לב."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה משפט אני אומר/ת לעצמי בדרך כלל?",
      "איך נשמע משפט עדין יותר?",
      "מה אני רוצה להרגיש אחרי פעם הבאה?"
    ],
      [
      "איזה משפט אני אומר/ת לעצמי בדרך כלל?",
      "איך נשמע משפט עדין יותר?",
      "מה אני רוצה להרגיש אחרי פעם הבאה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני נותן/ת למה שעלה להיות כאן."
    ],
      [
      "אני נותן/ת למה שעלה להיות כאן."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת.",
      "נשימה אחת."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "בחירת חיבור",
    opening: localizedGenderNode(
      [
      "היום אני נשאר/ת עם עצמי סביב הנושא הזה.",
      "אני לא פותר/ת.",
      "אני רק שם/ה לב."
    ],
      [
      "היום אני נשאר/ת עם עצמי סביב הנושא הזה.",
      "אני לא פותר/ת.",
      "אני רק שם/ה לב."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מהי בחירת חיבור קטנה עבורי?",
      "מה מקשה עלי לבחור בזה?",
      "איזו תנועה קטנה אפשר לעשות היום?"
    ],
      [
      "מהי בחירת חיבור קטנה עבורי?",
      "מה מקשה עלי לבחור בזה?",
      "איזו תנועה קטנה אפשר לעשות היום?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני נותן/ת למה שעלה להיות כאן."
    ],
      [
      "אני נותן/ת למה שעלה להיות כאן."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת.",
      "נשימה אחת."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "כיוון קטן להמשך",
    opening: localizedGenderNode(
      [
      "היום אני נשאר/ת עם עצמי סביב הנושא הזה.",
      "אני לא פותר/ת.",
      "אני רק שם/ה לב."
    ],
      [
      "היום אני נשאר/ת עם עצמי סביב הנושא הזה.",
      "אני לא פותר/ת.",
      "אני רק שם/ה לב."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "לאן אני רוצה שהכיוון ילך?",
      "איזה ערך קטן חשוב לי כאן?",
      "איזה הרגל קטן יכול לעזור?"
    ],
      [
      "לאן אני רוצה שהכיוון ילך?",
      "איזה ערך קטן חשוב לי כאן?",
      "איזה הרגל קטן יכול לעזור?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני נותן/ת למה שעלה להיות כאן."
    ],
      [
      "אני נותן/ת למה שעלה להיות כאן."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת.",
      "נשימה אחת."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "סגירה עדינה",
    opening: localizedGenderNode(
      [
      "היום אני נשאר/ת עם עצמי סביב הנושא הזה.",
      "אני לא פותר/ת.",
      "אני רק שם/ה לב."
    ],
      [
      "היום אני נשאר/ת עם עצמי סביב הנושא הזה.",
      "אני לא פותר/ת.",
      "אני רק שם/ה לב."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה למדתי עלי במסע הזה?",
      "מה יהיה משפט חזרה לרגעים קשים?",
      "איך אני רוצה לזכור את הנשימה הזאת?"
    ],
      [
      "מה למדתי עלי במסע הזה?",
      "מה יהיה משפט חזרה לרגעים קשים?",
      "איך אני רוצה לזכור את הנשימה הזאת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני בוחר/ת נוכחות לפני תגובה."
    ],
      [
      "אני בוחר/ת נוכחות לפני תגובה."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת.",
      "נשימה אחת."
    ),
  },
].map(buildNormalizedDay);

export const childrenWhoLiveInAnotherCountryFarAwayBlueprintHe = buildNormalizedPilotBlueprint({
  id: "children_who_live_in_another_country_far_away_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "children_who_live_in_another_country_far_away",
  category: "parenting_children",
  journeyName: {
    he: "ילדים שחיים במדינה אחרת / רחוקים",
    en: "Children who live in another country / far away",
    es: "Niños que viven en otro país/lejos — 18 ימים",
  },
  days,
});

export default childrenWhoLiveInAnotherCountryFarAwayBlueprintHe;
